<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M3.83105 12.75L6.86688 8.84818C8.53628 6.70257 11.8137 6.81149 13.337 9.0632L15.8311 12.75M3.83105 12.75V4M3.83105 12.75V15.25C3.83105 15.6642 4.16684 16 4.58105 16H15.8311" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'PercentileIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>